// Dynamic file-type fields carry their value as a `File[]` (see DynamicFileUploadField's
// rhf.onChange). Detecting them by shape (rather than schema lookup) lets both the
// persisted-store partializer and the multipart submit builder stay schema-agnostic.
export function isFileArray(value: unknown): value is File[] {
  return Array.isArray(value) && value.some((entry) => entry instanceof File);
}
